import React from "react";
import img8 from "../imgs/img8.png";
import img9 from "../imgs/img9.png";
import img10 from "../imgs/img10.png";
import img11 from "../imgs/img11.png";
import img12 from "../imgs/img12.png";
import img13 from "../imgs/img13.png";

export default function Col() {
  const data = [
    { img: img8, text: "Endless Anime & Manga – From timeless classics to the latest hits, it’s all here." },
    { img: img9, text: "Break all the language barriers with our SUB and DUB to make sure you can enjoy them without limits." },
    { img: img10, text: "Crystal-Clear Streaming . Enjoy smooth, high-quality playback anytime, anywhere." },
    { img: img11, text: "Stay Ahead of the Curve . Be the first to watch new episodes and read fresh manga chapters." },
    { img: img12, text: "Stream or Download Anytime . Watch online or save your favorites to enjoy offline." },
    { img: img13, text: "Stay Organized Your Way. Create your own favorites list, mark shows as watched, or save them for later." },
  ];

  return (
<div className="w-[90%] mx-auto my-10 flex flex-col gap-6">
  {data.map((item, index) => (
    <div
      key={index}
      className="flex flex-row items-center justify-between gap-2 px-[2%] py-[7%]"
    >
      {/* Image */}
      <img
        src={item.img}
        alt={`img-${index}`}
        className="w-[22%] h-auto"
      />

      {/* Text */}
      <div className="w-[65%] text-white text-[15px] font-bold">
        <p>{item.text}</p>
      </div>
    </div>
  ))}
</div>

  );
}
